<template>
  <!--main-->
  <div id="main" class="wrap wrap-content">
    <section class="section-block s1">
      <div class="s1-block s1-left">
        <div class="s1-left__wrap">
          <div class="s1-left__title-tag">
            <img src="@/assets/images/01/Title_01.svg" alt="2022年度重磅登場" />
          </div>
          <div class="s1-left__title">
            PHOTOSHOP大神
            <span>游閔州來襲</span>
          </div>
          <div class="s1-left__info">
            <h1 class="h1">商業精修合成高階實戰</h1>
            <span>升職、加薪、接案 完成制霸！</span>
          </div>
        </div>
      </div>
      <div class="s1-block s1-right">
        <div class="s1-right__bg"></div>
      </div>
    </section>
    <section class="section-block s2">
      <div class="s2-block">
        <div class="s2-block__title">
          <img src="@/assets/images/02/Title_02.svg" alt="2022年度重磅登場" />
        </div>
        <ul class="s2-block__item">
          <li>
            <div class="s2-block__item-img">
              <img
                src="@/assets/images/02/01.png"
                alt="PS技術卡關
成品缺乏真實質感"
              />
            </div>
            <p class="s2-block__item-info">
              <span>PS技術卡關</span>
              <span>成品缺乏真實質感</span>
            </p>
          </li>
          <li>
            <div class="s2-block__item-img">
              <img
                src="@/assets/images/02/02.png"
                alt="找不到適合素材
光影調色沒概念"
              />
            </div>
            <p class="s2-block__item-info">
              <span>找不到適合素材</span>
              <span>光影調色沒概念</span>
            </p>
          </li>
          <li>
            <div class="s2-block__item-img">
              <img
                src="@/assets/images/02/03.png"
                alt="研究很多案例
還是做不出腦中畫面"
              />
            </div>
            <p class="s2-block__item-info">
              <span>研究很多案例</span>
              <span>還是做不出腦中畫面</span>
            </p>
          </li>
        </ul>
      </div>
    </section>
    <section class="section-block-3 s3">
      <div class="s3-wrap">
        <div class="s3-block-t">
          <div class="s3-block s3-block-t__left">
            <div class="s3-block-t__left-img s3-block-t__left-img1">
              <img src="@/assets/images/03-04/Teacher.png" alt="Teacher" />
            </div>
            <div class="s3-block-t__left-img s3-block-t__left-img2">
              <img src="@/assets/images/03-04/01.jpg" alt="image02" />
            </div>
          </div>
          <div class="s3-block s3-block-t__right">
            <h2 class="h2">「專業，也可以很簡單」</h2>
            <div class="s3-block-t__right-title">
              <h3 class="h3">游閔州<span>James</span></h3>
              <div class="s3-description">
                <span>台灣Photoshop影像合成大師</span>
                <a
                  href="https://www.flickr.com/photos/145442932@N03/sets/72157718399784637/with/51667480508/"
                  target="_blank"
                  >觀看更多作品</a
                >
              </div>
              <div class="s3-block-t__right-title-info">
                <p>
                  台灣Photoshop教學知名講師，業界從業經驗超過 25 年、接案資歷 19
                  年，專精於商業廣告精修、影像後製合成。
                </p>
                <p>
                  曾任博文廣告設計師、極佳創意＆上海 Symbidia
                  網路科技藝術總監，並出版過十餘本以上專業 Photoshop
                  教學工具書。擅長用基本的概念與原理切入，著重傳授扎實技術與觀念，不僅能讓初學者可以少走學習冤枉路，連業界設計師上課後都能突破多年瓶頸，邁向職場康莊大道。
                </p>
                <div class="s3-block-t__right-item">
                  <p>
                    <span>設計經歷：</span>
                    <span>2003 擔任 SOHO 與 Photoshop 講師至今</span>
                    <span>2001 上海 Symbidia 網路科技 藝術總監</span>
                    <span>2000 上海極佳創意 藝術總監</span>
                    <span>2000 極佳創意 藝術總監</span>
                    <span>1999 極佳創意 設計</span>
                    <span>1998 博文廣告 設計</span>
                    <span>1997 攝影人專業影像 設計</span>
                    <span>1996 漢曜彩色印刷 設計</span>
                  </p>
                  <p>
                    <span>出版作品：</span>
                    <span>Photoshop 5.5 影像密碼</span>
                    <span>Photoshop 6.0 影像密碼 / 影像密碼 典藏版</span>
                    <span>Photoshop 解像（有簡體版）</span>
                    <span>Photoshop 7.0 誕生</span>
                    <span>Photoshop 影像密碼《人性．機械制》</span>
                    <span>Photoshop 影像密碼《解密．典藏集》</span>
                    <span>Photoshop 影像密碼《頹廢．後現代》</span>
                    <span>Photoshop 影像密碼《想像與現實》</span>
                    <span>Photoshop 解構 1、解構 2</span>
                    <span>Photoshop 影像密碼《不存在主義》</span>
                  </p>
                </div>
                <div class="s3-block-t__left-img s3-block-t__left-img3">
                  <img src="@/assets/images/03-04/01.jpg" alt="image03" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="s3-block-b grid-wrap">
          <div class="item item1 item1-1" tabindex="1"></div>
          <div class="item item2 item1-2" tabindex="2"></div>
          <div class="item item3 item1-3" tabindex="3"></div>
          <div class="item item4 item1-4" tabindex="4"></div>
          <div class="item item5 item1-5" tabindex="5"></div>
          <div class="item item6 item1-6" tabindex="6"></div>
        </div>
      </div>
    </section>
    <section class="section-block s4">
      <div class="s4-block">
        <div class="s4-block__title">
          <img
            src="@/assets/images/05-06/Title_05.svg"
            alt="2022年度重磅登場"
          />
        </div>
        <div class="s4-block-description">
          <h3 class="h3">業界公認最硬核的「專業影像編修技術」</h3>
          <p>48HR 從核心概念到進階攻略</p>
          <p>學習超越業界水準的細緻修圖與光影調色！</p>
        </div>
        <!-- * 左右排列圖文相簿 * -->
        <div class="cards">
          <!-- * 第一個項目靠左（.c-align-left） -->
          <!-- * 第一個項目靠右（.c-align-right） -->
          <!-- * 垂直置中（.c-align-h-center） -->
          <ul class="c-align c-align-left c-align-h-center">
            <li class="card-border">
              <img src="@/assets/images/05-06/05_01.jpg" alt="image01" />
            </li>
            <li class="card-right">
              <div class="card-content">
                <div class="card-title title-num title-01">細緻人像精修</div>
                <p>
                  快速建立PS合成概念，傳授商業人像精修需要注意的所有細節，並實際應用在修圖上，訓練學員具備全方位修圖能力。
                </p>
                <ul class="dots-list">
                  <li>
                    專業級商業人像精修實戰演練：膚質自然精修、髮絲完美去背、圖層光影調整
                  </li>
                  <li>建立圖層混合概念及高階應用技法</li>
                  <li>調亮、調案工具延伸至去背應用</li>
                  <li>變形功能與明暗塑造繪製</li>
                </ul>
              </div>
            </li>
          </ul>
          <ul class="c-align c-align-right c-align-h-center">
            <li class="card-border">
              <img src="@/assets/images/05-06/05_02.jpg" alt="image01" />
            </li>
            <li class="card-right-re">
              <div class="card-content">
                <div class="card-title title-num title-02">
                  商業廣告產品高階修圖
                </div>
                <p>
                  商品修圖是商業攝影、平面與廣告設計中很重要的項目，因此要成為專業影像工作者，這是不可或缺的重要技能！
                </p>
                <ul class="dots-list">
                  <li>
                    熟悉圖層混合模式/灌入/遮色片概念：正確的運用圖層混合處理各種刁鑽的創意需求
                  </li>
                  <li>漸層工具、商品修圖的立體概念</li>
                  <li>專業級選取範圍技法實戰演練</li>
                </ul>
              </div>
            </li>
          </ul>
          <ul class="c-align c-align-left c-align-h-center">
            <li class="card-border">
              <img src="@/assets/images/05-06/05_03.jpg" alt="image01" />
            </li>
            <li class="card-right card-bg">
              <div class="card-content">
                <div class="card-title title-num title-03">超現實影像合成</div>
                <p>
                  無論接案或就職，應付公司或客戶千奇百怪的創意需求必須有扎實的影像合成能力，正確運用技巧及工具可處理各種刁鑽的創意需求，例如透明物合成、替換材質等，能輕易做出看似困難的合成，提升技術水平。
                </p>
                <ul class="dots-list">
                  <li>探討圖層混合模式的深入應用</li>
                  <li>高階影像合成精修示範＆實戰演練</li>
                  <li>深度業界經驗分享</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="section-block s5">
      <div class="s5-block">
        <div class="s5-block__title">
          <img src="@/assets/images/07/Title_07.svg" alt="2022年度重磅登場" />
        </div>
        <div class="s5-content">
          <div class="s5-content-card s5-left">
            <div class="s5-title s5-left-t">赫綵PS課程</div>
            <ul>
              <li>
                <h3 class="h3">業界師資手把手教學</h3>
                <p>
                  二十年以上業界經驗師資傳授PS精髓，學習有不懂當場就能解決，成長更快速
                </p>
              </li>
              <li>
                <h3 class="h3">商業案例做中學</h3>
                <p>
                  實際操作業界中最常接觸的作品案例，從中了解設計原理及思路，累積更強的實戰經驗
                </p>
              </li>
              <li>
                <h3 class="h3">高效產出作品集</h3>
                <p>
                  透過完整課程培訓，即可迅速累積大量作品集，結業後接軌業界就職接案超順利
                </p>
              </li>
            </ul>
          </div>
          <div class="s5-content-card s5-right">
            <div class="s5-title s5-right-t">自學PS課程</div>
            <ul>
              <li>
                <h3 class="h3">學習週期漫長</h3>
                <p>
                  網路影片品質參差不齊，讓新手在自學時難以將技法融會貫通，導致學習效率變低
                </p>
              </li>
              <li>
                <h3 class="h3">作品效果不如預期</h3>
                <p>
                  相較於實體教學，自學時沒有老師從旁輔導、檢視學習成果，產出作品難以達到業界水準
                </p>
              </li>
              <li>
                <h3 class="h3">成長速度較緩慢</h3>
                <p>
                  只會使用軟體卻缺乏設計思維、進步空間有限；沒有紮實基礎難以進入職場或接案
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="section-block s6">
      <div class="s6-block">
        <div class="s6-block__title">
          <span>領先業界 PS大師親臨指導 </span>
          名額有限 先搶先贏
        </div>
        <ul class="s6-item">
          <li>
            <div class="s6-list__t">
              <img src="@/assets/images/08/Card_1.png" alt="站前學院" />
            </div>
            <div class="s6-list__b s6-list__b-m">
              <img src="@/assets/images/08/Card_2.png" alt="站前學院" />
            </div>
          </li>
          <li>
            <div class="s6-list__t">
              <img src="@/assets/images/08/Card_5.png" alt="中壢學院" />
            </div>
            <div class="s6-list__b s6-list__b-m">
              <img src="@/assets/images/08/Card_3.png" alt="台中學院" />
            </div>
          </li>
          <li>
            <div class="s6-list__t">
              <img src="@/assets/images/08/Card_4.png" alt="站前學院" />
            </div>
            <div class="s6-list__b s6-list__b-m">
              <img src="@/assets/images/08/Card_6.png" alt="東區學院" />
            </div>
          </li>
        </ul>
        <div class="s6-btn">
          <a href="#1">搶先預約卡位</a>
        </div>
      </div>
    </section>
    <section class="section-block s7">
      <div class="s7-block">
        <div class="s7-block__title">
          <span>四大必學POINT</span>
          大師不藏私 精修合成技法紮實學
        </div>
        <ul class="s7-item">
          <li>
            <figure>
              <img src="@/assets/images/09/09_01.jpg" alt="紮實系統化教學" />
            </figure>
            <div class="s7-info">
              <p class="s7-title">Point 1 - 紮實系統化教學</p>
              <p class="s7-text">
                全程授課模擬業界接案實際流程產出專業等級設計作品集
              </p>
            </div>
          </li>
          <li>
            <figure>
              <img src="@/assets/images/09/09_02.jpg" alt="教學技術含金量高" />
            </figure>
            <div class="s7-info">
              <p class="s7-title">Point 2 - 教學技術含金量高</p>
              <p class="s7-text">
                業界人才稀缺、接案金額超乎想像結業即具備接案實戰力
              </p>
            </div>
          </li>
          <li>
            <figure>
              <img src="@/assets/images/09/09_03.jpg" alt="獨家精修案例教學" />
            </figure>
            <div class="s7-info">
              <p class="s7-title">Point 3 - 獨家精修案例教學</p>
              <p class="s7-text">
                James從業經驗超過25年獨家傳授從未公開過「隱藏版精華實戰案例」
              </p>
            </div>
          </li>
          <li>
            <figure>
              <img src="@/assets/images/09/09_04.jpg" alt="打造高度學習成效" />
            </figure>
            <div class="s7-info">
              <p class="s7-title">Point 4 - 打造高度學習成效</p>
              <p class="s7-text">
                實體課程即時解答學習疑難雜症，超深度設計經驗分享
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="section-block s8">
      <div class="s8-block">
        <div class="s8-block-item s8-block__left">
          <div class="s8-img">
            <img src="@/assets/images/10/10_01.jpg" alt="紮實系統化教學" />
            <p>
              PS大師設計講座
              <span>線下 3 小時精華課程</span>
              <span>NT$1,800</span>
            </p>
          </div>
          <div class="s8-img">
            <img src="@/assets/images/10/10_02.jpg" alt="紮實系統化教學" />
            <p>
              全方位線上課程
              <span>180堂設計師Online必修課</span>
              <span>NT$1,590</span>
            </p>
          </div>
        </div>
        <div id="1" class="s8-block-item s8-block__right">
          <div class="s8-block__title">立即卡位！搶先了解課程資訊</div>
          <p>填寫資料即可獲得限量學習好禮</p>
          <p>『實體設計講座』及『免費線上課程』</p>
          <p>好禮兌換將由專人與你聯繫</p>
          <FormSingle />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import FormSingle from "@/components/FormSingle.vue";

export default {
  name: "HomeView",
  components: {
    FormSingle,
  },
};
</script>


<style lang="scss">
@import "@/assets/scss/mixin.scss";
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/reset.scss";
@import "@/assets/scss/main.scss";
@import "@/assets/scss/grid.scss";

.section-block {
  width: calc(100% - 40px);
  margin: 0 auto;
  margin-top: 3rem;

  &:nth-child(1) {
    margin-top: 0;
  }

  @include min-width(768px) {
    width: calc(100% - 80px);
    margin-top: 5rem;
  }

  @include min-width(1024px) {
    width: 935px;
  }

  @include min-width(1440px) {
    width: 1200px;
  }

  @include min-width(1920px) {
    width: 1400px;
  }

  &:first-child {
    margin-top: 0;
  }
}

//section1
.s1 {
  padding-top: 3rem;

  @include min-width(768px) {
    padding-top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .s1-block {
  }

  .s1-left {
    width: 100%;
    position: relative;

    &:after {
      content: "";
      width: 100%;
      position: absolute;
      z-index: -1;
      top: 20px;
      left: 0%;
      padding-bottom: 140%;
      background: url("@/assets/images/01/Patterns_01.svg") no-repeat
        center/contain;
    }

    @include min-width(768px) {
      width: 50%;

      &:after {
        top: -50px;
        left: -10%;
      }
    }

    @include min-width(1024px) {
      width: 45%;

      &:after {
        top: -86%;
        left: -12%;
      }
    }

    @include min-width(1280px) {
      &:after {
        top: -12%;
      }
    }

    @include min-width(1440px) {
      width: 50%;

      &:after {
        top: -193%;
        left: -8%;
      }
    }

    @include min-width(1920px) {
      width: 45%;

      &:after {
        top: -98%;
        left: -35%;
      }
    }

    .s1-left__wrap {
      @include min-width(1024px) {
        margin-top: -8rem;
      }

      @include min-width(1440px) {
        margin-top: -16rem;
      }

      @include min-width(1920px) {
        margin-top: -8rem;
      }
    }

    .s1-left__title-tag {
      width: 60%;

      > img {
        width: 100%;
      }

      @include min-width(768px) {
        width: 70%;
      }

      @include min-width(1025px) {
        width: auto;

        > img {
          width: auto;
        }
      }
    }

    .s1-left__title {
      width: 100%;
      margin-top: 2rem;
      font-weight: 700;
      letter-spacing: 5px;
      font-size: 24px;
      font-family: "Noto Serif TC", serif;
      color: $color-white;
      text-shadow: 0px 0px 25px rgba(0, 0, 0, 0.25);

      > span {
        display: block;
        line-height: 1.2;
        font-size: 60px;
        color: $color-white;
        text-shadow: 0px 0px 25px rgba(0, 0, 0, 0.25);
      }

      @include min-width(768px) {
        font-size: 3vw;

        > span {
          font-size: 8vw;
        }
      }

      @include min-width(1024px) {
        > span {
          font-size: 6.5vw;
        }
      }

      @include min-width(1280px) {
        font-size: 2vw;

        > span {
          font-size: 5vw;
        }
      }

      @include min-width(1440px) {
        font-size: 3vw;

        > span {
          font-size: 6vw;
        }
      }

      @include min-width(1920px) {
        font-size: 2vw;

        > span {
          font-size: 5vw;
        }
      }
    }

    .s1-left__info {
      .h1 {
        display: inline-block;
        position: relative;
        margin-top: 2rem;
        margin-bottom: 0;
        letter-spacing: 0.05em;
        font-size: 25px;
        color: $color-primary-2;

        &::before {
          content: "";
          -webkit-animation: sparkle 4s forwards;
          -webkit-animation-timing-function: linear;
          background: #fff;
          border-radius: 100%;
          box-shadow: 0 0 5px #fff, 0 0 10px #fff, 0 0 15px #fff, 0 0 20px #fff,
            0 0 25px #fff, 0 0 30px #fff, 0 0 35px #fff;
          content: "";
          display: block;
          width: 4px;
          height: 4px;
          opacity: 0.7;
          position: absolute;
          right: 0;
        }

        &::after {
          content: "商業精修合成高階實戰";
          background-position: -180px;
          animation: flare 4s forwards;
          animation-timing-function: linear;
          background-image: linear-gradient(
            65deg,
            transparent 50%,
            rgba(255, 255, 255, 0.83) 0%,
            rgba(255, 255, 255, 0.83) 57%,
            transparent 37%,
            transparent 100%
          );
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: #fff;
          display: block;
          position: absolute;
          width: 100%;
          height: 70px;
          left: 0.12em;
          top: 0.1em;
        }

        @include min-width(768px) {
          font-size: 2.5vw;
        }

        @include min-width(1025px) {
          font-size: 2.2vw;

          &::before {
            width: 6px;
            height: 6px;
          }
        }

        @include min-width(1280px) {
          font-size: 2vw;
        }
      }

      > span {
        position: relative;
        display: block;
        font-weight: 500;
        letter-spacing: 0.05em;
        font-size: 25px;
        color: $color-primary-2;

        @include min-width(768px) {
          margin-top: 0.5rem;
          font-size: 2.5vw;
        }

        @include min-width(1025px) {
          font-size: 2.2vw;
        }

        @include min-width(1280px) {
          font-size: 2vw;
        }

        &::after {
          content: "升職、加薪、接案 完成制霸！";
          background-position: -180px;
          animation: flare 4s forwards;
          animation-timing-function: linear;
          background-image: linear-gradient(
            65deg,
            transparent 20%,
            rgba(255, 255, 255, 0.83) 20%,
            rgba(255, 255, 255, 0.83) 27%,
            transparent 27%,
            transparent 100%
          );
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: #fff;
          display: block;
          position: absolute;
          width: 100%;
          height: 70px;
          left: 0.12em;
          top: 0.1em;
        }
      }

      @keyframes flare {
        0% {
          background-position: -180px;
        }
        30% {
          background-position: 500px;
        }
        40% {
          opacity: 0;
        }
        100% {
          opacity: 0;
          background-position: 500px;
        }
      }

      @keyframes sparkle {
        0% {
          opacity: 0;
        }
        30% {
          opacity: 0;
        }
        40% {
          opacity: 0.8;
        }
        60% {
          opacity: 0;
        }
        100% {
          opacity: 0;
        }
      }
    }
  }

  .s1-right {
    width: 100%;

    @include min-width(768px) {
      width: 50%;
      margin-right: -5%;
    }

    @include min-width(1024px) {
      width: 60%;
    }

    @include min-width(1440px) {
      width: 50%;
    }

    @include min-width(1920px) {
      width: 55%;
    }
  }

  .s1-right__bg {
    width: 100%;
    padding-bottom: 124%;
    background: url("@/assets/images/01/VI-Mobile.png") no-repeat center/contain;

		@include min-width(768px) {
    width: 132%;
    padding-bottom: 145%;
		background: url("@/assets/images/01/VI.png") no-repeat center/contain;
		}

    @include min-width(1440px) {
      width: 140%;
      padding-bottom: 160%;
    }

    @include min-width(1920px) {
      width: 132%;
      padding-bottom: 145%;
    }
  }
}

//section2
.s2 {
  .s2-block__title {
    display: flex;
    justify-content: center;
    position: relative;
    margin: 0 auto;

    > img {
      width: 100%;
    }

    @include min-width(768px) {
      width: 40%;

      &:after {
        content: "";
        width: 653px;
        height: 243px;
        display: block;
        position: absolute;
        top: 0;
        background: url("@/assets/images/02/Patterns_02.svg") no-repeat
          center/contain;
      }
    }

    @include min-width(1025px) {
      width: auto;

      > img {
        width: auto;
      }
    }
  }

  .s2-block__item {
    width: 100%;
    padding-left: 0;

    @include min-width(768px) {
      margin-top: 2rem;
      display: flex;
      justify-content: space-around;
    }

    @include min-width(1024px) {
      margin-top: 0rem;
    }

    > li {
      width: 100%;

      @include min-width(768px) {
        width: 33.33%;
      }

      .s2-block__item-img {
        display: flex;
        justify-content: center;

        > img {
          width: 100%;
        }
      }

      .s2-block__item-info {
        > span {
          display: block;
          color: $color-white;
          text-align: center;
          letter-spacing: 0.1em;
          font-size: 16px;
          line-height: 1.5;
          text-shadow: 0px 0px 10px #405753;

          @include min-width(768px) {
            font-size: 1.5vw;
          }

          @include min-width(1024px) {
            font-size: 1vw;
          }
        }
      }
    }
  }
}

//section3
.s3 {
  color: $color-white;
  background-color: $color-black;

  &.section-block-3 {
    margin-top: 5rem;
  }

  .s3-wrap {
    width: calc(100% - 40px);
    transition: 0.2s;
    margin: 0 auto;
    padding-top: 2rem;
    padding-bottom: 60px;

    @include min-width(768px) {
      width: calc(100% - 80px);
      padding-top: 115px;
      padding-bottom: 60px;
    }

    @include min-width(1024px) {
      padding: 115px 0;
      width: 935px;
    }

    @include min-width(1440px) {
      width: 1200px;
    }

    @include min-width(1920px) {
      width: 1400px;
    }

    .s3-block-t {
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      @include min-width(1024px) {
        width: 935px;
      }

      @include min-width(1440px) {
        width: 100%;
        flex-direction: row;
      }

      .s3-block {
        width: 100%;

        @include min-width(1440px) {
          width: 49%;
        }

        .s3-block-t__left-img {
          margin: 0 auto;

          &.s3-block-t__left-img1 {
            width: 100%;

            @include min-width(768px) {
              width: 55%;
            }
          }

          &.s3-block-t__left-img2 {
            display: none;

            @include min-width(1440px) {
              width: 100%;
              display: block;
            }
          }

          &.s3-block-t__left-img3 {
            width: 100%;
            margin-top: 1.5rem;
            display: block;

            @include min-width(1440px) {
              display: none;
            }
          }

          > img {
            width: 100%;
            margin-bottom: 0;
          }
        }
      }

      .h2 {
        font-weight: 100;
        font-size: 22px;
        text-align: center;
        color: $color-white;

        @include min-width(768px) {
          font-size: 40px;
          text-align: left;
        }
      }

      .s3-block-t__right-title {
        .h3 {
          margin-top: 2rem;
          font-weight: 700;
          font-size: 35px;
          color: $color-primary-3;
          letter-spacing: 0.23em;
          font-family: "Noto Serif TC", serif;
          text-align: center;

          @include min-width(768px) {
            margin-top: 3rem;
            font-size: 60px;
            text-align: left;
          }

          > span {
            margin-left: 1rem;
            font-weight: 700;
            font-size: 16px;
            letter-spacing: 0.3em;
            color: $color-primary-3;
            font-family: "inherit";

            @include min-width(768px) {
              font-size: 22px;
            }
          }
        }

        .s3-description {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;

          @include min-width(768px) {
            flex-direction: row;
          }

          > span {
            margin-bottom: 2rem;
            display: block;
            font-weight: 700;
            font-size: 14px;
            color: $color-white;
            letter-spacing: 0.3em;

            @include min-width(768px) {
              margin-bottom: 0;
              font-size: 22px;
            }
          }

          > a {
            padding: 0.5rem 1rem;
            display: inline-block;
            font-size: 18px;
            color: $color-primary-2;
            background-color: $color-primary-3;
            box-shadow: 0px 2px 10px #f0e7c8;
            border-radius: 5px;
            transition: 0.2s;
            text-decoration: none;

            @include min-width(1025px) {
              display: block;

              &:hover {
                transition: 0.2s;
                background: linear-gradient(270deg, #bbd293 0%, #c8c0b4 100%);
                box-shadow: none;
              }
            }
          }
        }

        .s3-block-t__right-title-info {
          margin-top: 3rem;

          > p {
            padding: 0 2rem;
            font-size: 14px;
            color: $color-gray-5;

            @include min-width(768px) {
              padding: 0;
              font-size: 16px;
            }
          }
        }
      }
    }

    .grid-wrap {
      height: 900px;
      margin-top: 1.5rem;
      display: grid;
      width: 100%;
      gap: 1.5rem 1.5rem;
      grid-template-columns: repeat(3);
      grid-template-rows: auto;
      grid-template-areas:
        "photo1 photo2"
        "photo3 photo3"
        "photo4 photo4"
        "photo5 photo6";

      @include min-width(768px) {
        height: 1500px;
      }

      @include min-width(1025px) {
        height: 600px;
        grid-template-areas:
          "photo1 photo2 photo3 photo3"
          "photo1 photo2 photo3 photo3"
          "photo4 photo4 photo5 photo6"
          "photo4 photo4 photo5 photo6";
      }
    }

    .item {
      overflow: hidden;
      border-radius: 5px;

      > figure {
        height: 100%;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  //圖片網格
  .item1 {
    grid-area: photo1;
  }
  .item2 {
    grid-area: photo2;
  }
  .item3 {
    grid-area: photo3;
  }
  .item4 {
    grid-area: photo4;
  }
  .item5 {
    grid-area: photo5;
  }
  .item6 {
    grid-area: photo6;
  }

  //Grid 圖片背景設定
  .item1-1 {
    background: url("@/assets/images/03-04/02.jpg") no-repeat center/cover;
    //background-position: 50% 100%;
  }
  .item1-2 {
    background: url("@/assets/images/03-04/03.jpg") no-repeat center/cover;
  }
  .item1-3 {
    background: url("@/assets/images/03-04/04.jpg") no-repeat center/cover;
  }
  .item1-4 {
    background: url("@/assets/images/03-04/06.jpg") no-repeat center/cover;
  }
  .item1-5 {
    background: url("@/assets/images/03-04/05.jpg") no-repeat center/cover;
  }
  .item1-6 {
    background: url("@/assets/images/03-04/07.jpg") no-repeat center/cover;
  }
}

.s3-block-t__right-item {
  padding: 0 2rem;
  margin-top: 3rem;

  @include min-width(768px) {
    display: flex;
    padding: 0;
  }

  > p {
    width: 100%;
    font-size: 14px;

    @include min-width(768px) {
      width: 50%;
    }

    > span {
      margin-bottom: 0.25rem;
      display: block;
      color: $color-gray-5;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

//section4
.s4 {
  .s4-block__title {
    display: flex;
    justify-content: center;
    position: relative;
    margin: 0 auto;

    > img {
      width: 100%;
    }

    @include min-width(768px) {
      width: 40%;

      &:after {
        content: "";
        width: 500px;
        height: 145px;
        display: block;
        position: absolute;
        top: 0;
        background: url("@/assets/images/05-06/Patterns_05.svg") no-repeat
          center/contain;

        @include min-width(768px) {
          width: 500px;
          height: 145px;
          top: -50px;
        }

        @include min-width(1024px) {
          width: 1121px;
          height: 332px;
          top: 0;
        }
      }
    }

    @include min-width(1025px) {
      width: auto;

      > img {
        width: auto;
      }
    }
  }

  .s4-block-description {
    margin-top: 2rem;

    > .h3 {
      margin-bottom: 1rem;
      font-weight: 500;
      font-size: 15px;
      text-align: center;
      color: $color-primary-3;

      @include min-width(768px) {
        font-size: 36px;
      }
    }

    > p {
      margin-bottom: 0;
      line-height: 24px;
      font-weight: 700;
      font-size: 14px;
      text-align: center;
      color: $color-white;

      @include min-width(768px) {
        line-height: 34px;
        font-size: 22px;
        letter-spacing: 0.3em;
      }
    }
  }

  .cards {
    margin-top: 2.5rem;

    @include min-width(768px) {
      margin-top: 5rem;
    }
  }

  .card-border {
    border: 3px solid $color-primary-1;
    border-radius: 10px;
    overflow: hidden;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .card-right {
    margin-top: 1rem;

    @include min-width(768px) {
      margin-top: 0;
      padding-left: 2rem;
    }
  }

  .card-right-re {
    margin-top: 1rem;

    @include min-width(768px) {
      margin-top: 0;
      padding-right: 2rem;
    }
  }

  .card-content {
    .card-title {
      margin-bottom: 1rem;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      font-weight: 500;
      font-size: 24px;
      line-height: 36px;
      color: $color-primary-3;
      letter-spacing: 0.05em;
      text-shadow: 0px 0px 30px #bbd293;

      @include min-width(768px) {
        line-height: 52px;
        font-size: 22px;
      }

      @include min-width(1025px) {
        margin-bottom: 2rem;
        font-size: 24px;
      }

      @include min-width(1440px) {
        font-size: 36px;
      }

      &.title-01 {
        &:after {
          content: "";
          width: 60px;
          height: 50px;
          background: url("@/assets/images/05-06/05_01.svg") no-repeat
            center/contain;

          @include min-width(768px) {
            width: 60px;
            height: 50px;
          }

          @include min-width(1025px) {
            width: 100px;
            height: 60px;
          }

          @include min-width(1440px) {
            width: 155px;
            height: 95px;
          }
        }
      }

      &.title-02 {
        &:before {
          content: "";
          width: 60px;
          height: 50px;
          background: url("@/assets/images/05-06/05_02.svg") no-repeat
            center/contain;

          @include min-width(768px) {
            width: 60px;
            height: 50px;
          }

          @include min-width(1025px) {
            width: 100px;
            height: 60px;
          }

          @include min-width(1440px) {
            width: 155px;
            height: 95px;
          }
        }
      }

      &.title-03 {
        &:after {
          content: "";
          width: 60px;
          height: 50px;
          background: url("@/assets/images/05-06/05_03.svg") no-repeat
            center/contain;

          @include min-width(768px) {
            width: 60px;
            height: 50px;
          }

          @include min-width(1025px) {
            width: 100px;
            height: 60px;
          }

          @include min-width(1440px) {
            width: 155px;
            height: 95px;
          }
        }
      }
    }

    > p {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.05em;
      color: $color-gray-7;

      @include min-width(768px) {
        font-size: 12px;
        line-height: 20px;
      }

      @include min-width(1025px) {
        font-size: 16px;
        line-height: 26px;
      }
    }

    .dots-list {
      padding-left: 1rem;
      list-style-type: disc;

      > li {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.05em;
        color: $color-gray-7;

        @include min-width(768px) {
          font-size: 12px;
          line-height: 20px;
        }

        @include min-width(1025px) {
          font-size: 16px;
          line-height: 26px;
        }
      }
    }
  }

  .card-bg {
    position: relative;

    @include min-width(768px) {
      &:after {
        content: "";
        width: 748px;
        height: 593px;
        display: block;
        position: absolute;
        top: -73%;
        right: 0;
        z-index: 0;
        background: url("@/assets/images/05-06/Patterns_06.svg") no-repeat
          center/contain;
      }
    }
  }
}

//section5
.s5 {
  .s5-block__title {
    display: flex;
    justify-content: center;
    position: relative;
    margin: 0 auto;

    > img {
      width: 100%;
    }

    @include min-width(768px) {
      width: 45%;
    }

    @include min-width(1025px) {
      width: auto;

      > img {
        width: auto;
      }
    }
  }

  .s5-content {
    margin-top: 3rem;

    @include min-width(768px) {
      display: flex;
      justify-content: center;
    }

    .s5-content-card {
      width: 100%;
      position: relative;

      @include min-width(768px) {
        width: 49%;
      }

      @include min-width(1440px) {
        width: 32%;
      }

      > ul {
        padding-left: 0;
        position: relative;
        height: 450px;
        margin-top: 0.5rem;
        margin-bottom: 2rem;
        background-color: $color-white;
        border-radius: 16px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        @include min-width(376px) {
          height: 425px;
        }

        @include min-width(768px) {
          margin-top: 1rem;
          margin-bottom: 1rem;
          height: 520px;
        }

        @include min-width(1024px) {
          height: 520px;
        }

        @include min-width(1440px) {
          height: 550px;
        }

        &:after {
          content: "";
          display: block;
          position: absolute;
          right: 0;
          bottom: 0;
          width: 119px;
          height: 48px;
        }

        > li {
          padding: 1rem;

          @include min-width(768px) {
            padding: 2rem 1rem;
          }

          > .h3 {
            display: flex;
            position: relative;
            font-weight: 700;
            font-size: 18px;
            line-height: 28px;

            @include min-width(768px) {
              font-size: 18px;
              line-height: 28px;
            }

            @include min-width(1025px) {
              font-size: 20px;
              line-height: 32px;
            }
          }

          > p {
            margin-bottom: 0;
            padding-left: 2rem;
            font-weight: 400;
            font-size: 13px;
            line-height: 24px;
            letter-spacing: 0.05em;
            color: $color-gray-3;

            @include min-width(768px) {
              font-size: 13px;
              line-height: 24px;
            }

            @include min-width(1025px) {
              font-size: 16px;
              line-height: 26px;
            }
          }
        }
      }
    }

    .s5-left {
      margin-right: 1rem;

      &:after {
        @include min-width(1025px) {
          content: "";
          display: block;
          width: 267px;
          height: 555px;
          position: absolute;
          top: 0;
          left: -65%;
          background: url("@/assets/images/07/Patterns_07_01.svg") no-repeat
            center;
          background-size: contain;
        }
      }

      > ul {
        border: 5px solid $color-primary-3;

        &:after {
          background: url("@/assets/images/07/V.svg") no-repeat center/contain;
        }

        > li {
          border-bottom: 5px solid $color-primary-3;

          &:last-child {
            border-bottom: none;
          }

          > .h3 {
            color: $color-primary-2;

            &:before {
              content: "";
              width: 32px;
              height: 32px;
              display: block;
              background: url("@/assets/images/07/V_Normal.svg") no-repeat
                center/contain;
            }
          }
        }
      }
    }

    .s5-right {
      @include min-width(768px) {
        margin-left: 1rem;
      }

      &:after {
        @include min-width(1025px) {
          content: "";
          display: block;
          width: 293px;
          height: 776px;
          position: absolute;
          top: -15%;
          right: -20%;
          z-index: -1;
          background: url("@/assets/images/07/Patterns_07_02.svg") no-repeat
            center;
          background-size: contain;
        }
      }

      > ul {
        border: 5px solid $color-gray-5;

        &:after {
          background: url("@/assets/images/07/X.svg") no-repeat center/contain;
        }

        > li {
          border-bottom: 5px solid $color-gray-5;

          &:last-child {
            border-bottom: none;
          }
          > .h3 {
            color: $color-gray-5;

            &:before {
              content: "";
              width: 32px;
              height: 32px;
              display: block;
              background: url("@/assets/images/07/X_Normal.svg") no-repeat
                center/contain;
            }
          }
        }
      }
    }

    .s5-title {
      padding: 1rem 0;
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      border-radius: 10px;
      text-align: center;

      @include min-width(768px) {
        font-size: 18px;
        line-height: 24px;
      }

      @include min-width(1025px) {
        padding: 1.2rem 0;
        font-size: 22px;
        line-height: 32px;
      }

      > ul {
        margin-top: 1rem;
      }
    }

    .s5-left-t {
      color: $color-primary-2;
      background-color: $color-primary-3;
    }

    .s5-right-t {
      background-color: $color-gray-6;
    }
  }
}

//section6
.s6 {
  text-align: center;

  .s6-block__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 52px;
    color: $color-white;
    position: relative;

    @include min-width(768px) {
      font-size: 36px;
      letter-spacing: 0.05em;

      &:after {
        content: "";
        display: block;
        width: 168px;
        height: 194px;
        position: absolute;
        left: 50%;
        top: 0;
        margin-left: 200px;
        background: url("@/assets/images/08/Patterns_08.svg") no-repeat
          center/contain;
      }
    }

    > span {
      display: block;
      font-weight: 700;
      font-family: "Noto Serif TC", serif;
      font-size: 16px;
      line-height: 32px;
      letter-spacing: 0.1em;
      color: $color-white;

      @include min-width(768px) {
        font-size: 20px;
      }
    }
  }

  .s6-item {
    margin-top: 2rem;
    padding-left: 0;

    @include min-width(768px) {
      margin-top: 0;
      display: flex;
      justify-content: space-between;
      padding-left: 0;
    }

    > li {
      display: flex;
      justify-content: space-between;
      width: 100%;

      @include min-width(768px) {
        display: block;
        width: 30%;

        &:nth-child(1) {
          margin-top: 2rem;
        }

        &:nth-child(2) {
          margin-top: 7rem;
        }

        &:nth-child(3) {
          margin-top: 12rem;
        }
      }

      @include min-width(1440px) {
        width: 33%;
      }

      .s6-list__t {
        width: 48%;

        @include min-width(768px) {
          width: 100%;
          margin-bottom: 5rem;
        }

        > img {
          width: 100%;

          @include min-width(1440px) {
            width: auto;
          }
        }
      }

      .s6-list__b {
        width: 48%;

        > img {
          width: 100%;

          @include min-width(1440px) {
            width: auto;
          }
        }

        &.s6-list__b-m {
          margin-top: 3rem;
        }

        @include min-width(768px) {
          width: auto;

          &.s6-list__b-m {
            margin-top: 0;
          }
        }
      }
    }
  }

  .s6-btn {
    position: relative;
    z-index: 10;
    margin-top: 3rem;

    > a {
      display: inline-block;
      padding: 15px 37px;
      color: $color-primary-2;
      font-size: 18px;
      background: linear-gradient(270deg, #bbd293 0%, #ffd79a 100%);
      box-shadow: 0px 2px 10px #f0e7c8;
      border-radius: 5px;
      transition: 0.2s;
      text-decoration: none;

      @include min-width(1025px) {
        &:hover {
          background: linear-gradient(270deg, #bbd293 0%, #c8c0b4 100%);
          box-shadow: none;
        }
      }
    }
  }
}

//section7
.s7 {
  text-align: center;

  .s7-block__title {
    font-weight: 500;
    font-size: 22px;
    line-height: 52px;
    color: $color-white;
    position: relative;

    @include min-width(768px) {
      font-size: 36px;
      letter-spacing: 0.05em;

      &:after {
        content: "";
        display: block;
        width: 150px;
        height: 214px;
        position: absolute;
        top: -200%;
        background: url("@/assets/images/09/Patterns_09_01.svg") no-repeat
          center/contain;

        @include min-width(768px) {
          width: 150px;
        }

        @include min-width(1024px) {
          width: 424px;
          left: -10%;
        }
      }

      &:before {
        content: "";
        display: block;
        width: 272px;
        height: 366px;
        position: absolute;
        right: 0;
        top: -258%;
        margin-left: 200px;
        background: url("@/assets/images/09/Patterns_09_02.svg") no-repeat
          center/contain;

        @include min-width(768px) {
          width: 150px;
        }

        @include min-width(1024px) {
          width: 272px;
          right: -10%;
          top: -200%;
        }
      }
    }

    > span {
      display: block;
      font-weight: 700;
      font-family: "Noto Serif TC", serif;
      font-size: 16px;
      line-height: 32px;
      letter-spacing: 0.1em;
      color: $color-white;

      @include min-width(768px) {
        font-size: 20px;
      }
    }
  }

  .s7-item {
    margin-top: 3rem;
    padding-left: 0;

    @include min-width(768px) {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }

    > li {
      width: 100%;
      position: relative;
      margin-bottom: 1rem;
      border-radius: 10px;
      filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.25));
      transition: 0.2s;
      overflow: hidden;

      @include min-width(768px) {
        width: 45%;
        margin-bottom: 3rem;

        &:nth-child(3),
        &:nth-child(4) {
          margin-bottom: 0;
        }
      }

      > figure {
        width: 100%;
        margin-bottom: 0;

        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .s7-info {
        position: relative;
        z-index: 10;
        background-color: $color-primary-4;
        transition: 0.2s;

        @include min-width(1440px) {
          transform: translateY(-18%);

          &:after {
            content: "";
            display: block;
            width: 24px;
            height: 24px;
            position: absolute;
            left: 50%;
            margin-left: -12px;
            top: 15px;
            background: url("@/assets/images/09/Up_Normal.svg") no-repeat
              center/contain;
          }
        }

        @include min-width(1920px) {
          transform: translateY(-50%);
        }

        > p {
          margin-bottom: 0;
          padding: 20px 0 0 0;
          font-weight: 700;
          line-height: 35px;
          letter-spacing: 0.05em;
          color: $color-white;

          @include min-width(768px) {
            font-size: 18px;
          }

          @include min-width(1024px) {
            padding: 25px 0 0 0;
            font-size: 20px;
          }

          @include min-width(1440px) {
            padding: 45px 0 0 0;
            font-size: 24px;
          }

          &.s7-text {
            padding: 0rem 2rem 1.5rem 2rem;
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;

            @include min-width(768px) {
              font-size: 13px;
              line-height: 20px;
            }

            @include min-width(1024px) {
              padding: 1rem 4rem;
              font-size: 16px;
              line-height: 28px;
            }

            @include min-width(1440px) {
              padding: 1.5rem 7rem;
              font-size: 18px;
            }

            @include min-width(1920px) {
              font-size: 20px;
            }
          }
        }
      }

      @include min-width(1024px) {
      }

      @include min-width(1440px) {
        height: 450px;

        &:after {
          content: "";
          opacity: 0;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.343);
          transition: 0.2s;
        }

        &:hover {
          &:after {
            opacity: 1;
          }
          .s7-info {
            transform: translateY(-95%);

            @include min-width(1440px) {
              transform: translateY(-63%);
            }

            @include min-width(1920px) {
              transform: translateY(-95%);
            }
          }
        }
      }
    }
  }
}

//section8
.s8 {
  margin-top: 8rem;

  @include min-width(1024px) {
    margin-top: 15rem;
  }

  .s8-block {
    position: relative;

    @include min-width(1024px) {
      display: flex;
      justify-content: space-around;
    }

    &:before {
      @include min-width(768px) {
        content: "";
        width: 195px;
        height: 258px;
        position: absolute;
        top: 35%;
        z-index: -1;
        background: url("@/assets/images/10/Patterns_10_01.svg") no-repeat
          center/contain;
      }

      @include min-width(1024px) {
        width: 220px;
        top: -25%;
        left: -80px;
      }
    }

    &:after {
      @include min-width(768px) {
        content: "";
        width: 165px;
        height: 702px;
        position: absolute;
        top: 15%;
        right: 0px;
        z-index: -1;
        background: url("@/assets/images/10/Patterns_10_02.svg") no-repeat
          center/contain;
      }

      @include min-width(1024px) {
        width: 305px;
        top: 10%;
        right: -50px;
      }
    }

    .s8-block-item {
    }

    .s8-block__left {
      width: 100%;

      @include min-width(768px) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      @include min-width(1024px) {
        display: block;
        width: 50%;
      }

      @include min-width(1440px) {
        width: 40%;
      }

      @include min-width(1920px) {
        width: 35%;
      }
    }

    .s8-block__right {
      width: 100%;
      margin: 0 auto;
      text-align: center;

      @include min-width(768px) {
        width: 60%;
      }

      @include min-width(1024px) {
        width: 45%;
      }

      .s8-block__title {
        margin-bottom: 1rem;
        font-weight: 500;
        font-size: 22px;
        line-height: 52px;
        color: $color-white;

        @include min-width(768px) {
          margin-bottom: 2rem;
          letter-spacing: 0.05em;
          font-size: 3vw;
        }

        @include min-width(1024px) {
          font-size: 2.2vw;
        }

        @include min-width(1440px) {
          font-size: 2vw;
        }
      }

      > p {
        margin-bottom: 0;
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 0.05em;
        color: $color-white;
        line-height: 26px;

        @include min-width(1440px) {
          margin-bottom: 0.5rem;
        }
      }
    }

    .s8-img {
      width: 100%;
      height: 250px;
      margin-bottom: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      @include min-width(768px) {
        width: 48%;
        height: 250px;
      }

      @include min-width(1024px) {
        width: 100%;
        height: 330px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.5),
          rgba(0, 0, 0, 0.5)
        );

        border: 3px solid $color-primary-1;
        border-radius: 10px;
      }

      > p {
        margin-top: 100px;
        position: absolute;
        font-weight: 700;
        font-size: 30px;
        color: $color-primary-1;
        text-align: center;

        &:after {
          content: "";
          position: absolute;
          top: 0;
          left: 50%;
          margin-top: -80px;
          margin-left: -28px;
          width: 56px;
          height: 56px;
          display: block;
          background: url("@/assets/images/10/Gift.svg") no-repeat
            center/contain;
        }

        > span {
          display: block;
          color: $color-primary-1;

          &:nth-child(1) {
            margin-top: 1rem;
            font-weight: 400;
            font-size: 20px;
          }

          &:nth-child(2) {
            margin-top: 1rem;
            font-weight: 500;
            font-size: 20px;
            text-decoration-line: line-through;

            @include min-width(768px) {
              margin-top: 1rem;
            }

            @include min-width(1024px) {
              margin-top: 3rem;
            }
          }
        }
      }
    }
  }
}
</style>
